import {getTranslation} from './translations';

/* eslint-disable no-undef */
const ref = typeof Vue !== 'undefined' ? Vue.ref : null;
const watch = typeof Vue !== 'undefined' ? Vue.watch : null;

const template = `
	<div class="ubf-dynamicList__search">
		<label for="dlc_sort" class="ubf-dynamicList__searchLabel ubf-field__label">{{trans('search')}}</label>
		<input class="ubf-dynamicList__input ubf-field__input ubf-field__input--text" type="text" :value="localValue" :placeholder="description" @input="onInput" @change="onChange" />
	</div>
`;

export default {
    emits: ['input', 'change'],
    template: template,
    props: {
        label: String,
        value: String,
		description: String
    },
    setup: function (props, context) {
		const localValue = ref(props.value);
		watch(
			() => props.value, (newVal) => {localValue.value = newVal;}
		);
        return {
			trans: getTranslation,
			localValue: localValue,
            label: props.label,
			description: props.description,
		};
    },

	methods: {
		onInput: function(event) {
			this.$emit('input', event.target.value);
		},
		onChange: function(event) {
			this.$emit('change', event.target.value);
		},
	},
};

